import { Fragment } from "react";
const GameCapsuleTag = (props: any) => {
  return (
    <Fragment>
      {props.genres ? (
        <div className="px-3 py-1 bg-theme-surface">
          <div className="flex w-full h-full justify-center items-center text-xs">
            <p className="text-theme-text font-display text-[13px] font-semibold text-center">
              {props.title}
            </p>
          </div>
        </div>
      ) : props.article && props.small ? (
        <a href={`/game/${props.gameId}`} className="relative my-auto">
          <div className="px-2.5 py-1 bg-signal hover:bg-[#0047CC] transition-colors cursor-pointer">
            <div className="flex w-full h-full justify-center items-center">
              <p className="text-white font-display text-xs font-semibold text-center leading-none">
                {props.title}
              </p>
            </div>
          </div>
        </a>
      ) : props.article ? (
        <a href={`/game/${props.gameId}`} className="relative my-auto">
          <div className="px-3.5 py-1 bg-signal hover:bg-[#0047CC] transition-colors cursor-pointer">
            <div className="flex w-full h-full justify-center items-center text-xs">
              <p className="text-white font-display text-[13px] font-semibold text-center">
                {props.title}
              </p>
            </div>
          </div>
        </a>
      ) : (
        <a href={`/game/${props.gameId}`} className="relative block py-2">
          <div className="px-3 py-1 bg-theme-surface hover:bg-black/10 dark:hover:bg-white/15 transition-colors cursor-pointer">
            <div className="flex w-full h-full justify-center items-center">
              <p
                className="text-theme-text font-display text-[13px] font-semibold text-center line-clamp-1"
                title={props.title}
              >
                {props.title}
              </p>
            </div>
          </div>
        </a>
      )}
    </Fragment>
  );
};

export default GameCapsuleTag;
